import { Injectable } from '@angular/core';
import {protectedResources} from "../../auth-config";
import { HttpClient } from "@angular/common/http";
import {map} from "rxjs/operators";
import {Observable, of, tap} from "rxjs";
import {Project} from "../models/project.model";
import {saveAs} from "file-saver";
import {BuildKit} from "../../shared/models/build-kit.model";
import camelcaseKeys from "camelcase-keys";
import {v4 as uuidv4} from 'uuid';

@Injectable({
  providedIn: 'root'
})
export class ProjectService {

  brennerSoftwareApiEndpoint: string = protectedResources.BrennerSoftwareApi.endpoint;

  constructor(
    private http: HttpClient
  ) {}

  get(): Observable<Project[]>{
    return this.http.get<any[]>(this.brennerSoftwareApiEndpoint + `project/getList/`);
  }

  update(updatedProject: any): Observable<Project>{
    return this.http.post<any>(this.brennerSoftwareApiEndpoint + 'project/modify/',
      camelcaseKeys(updatedProject as any , {deep:true, pascalCase: true}))
      .pipe(map(x => x.data));
  }

  create(newProject: any): Observable<Project>{
    return this.http.post<any>(this.brennerSoftwareApiEndpoint + 'project/create/',
      camelcaseKeys(newProject as any , {deep:true, pascalCase: true}))
      .pipe(map(x => x.data));
  }


  remove(projectId: string): Observable<any>{
    return this.http.delete<any>(this.brennerSoftwareApiEndpoint + `project/delete/${projectId}`);
  }

  verifyDeleteIsValid(projectId: string): Observable<any>{
    return this.http.get<any>(this.brennerSoftwareApiEndpoint + `project/verifyDeleteIsValid/${projectId}`);
  }
}
